import React, { useCallback, useMemo } from 'react';
import { Box, RawButton, ShimmerBox, Text, useWatch } from '@common-fe/common-fe';
import styled from 'styled-components';

import { ROUTES } from '@/common';
import { useBreadcrumbs } from '@/modules/core/hooks';
import { useScrollToModule } from '@/utils';

import { usePermissionsListQuery } from '../queries';
import { useRouteMatch } from 'react-router-dom';



const StyledText = styled(Text)`

`;
const StyledButton = styled(RawButton)`
  &:hover {
    ${StyledText} {
      color: ${({ theme}) => theme.colors.textAccent}
    }
   
  }
`;

interface Props {
  isLoading?: boolean;
}
const RoleSetupSidebar: React.FC<Props> = ({ isLoading }) => {
  const { path } = useRouteMatch();
  const { groups } = usePermissionsListQuery({});
  const name = useWatch({
    name: 'name'
  });
  useBreadcrumbs([{
    route: ROUTES.ROLES_AND_SECURITY,
    title: 'Roles and Security',
  },
  {
    route: ROUTES.ROLE_SETUP,
    title: name,
  }], [name], {
    backBtn: true,
  });
  const handleScroll = useScrollToModule('role_setup', 100);
  const handleClick = useCallback((key: string) => () => {
    handleScroll(key);
 
  }, [handleScroll]);
  const isRoleEditPage = useMemo(() => path === ROUTES.ROLE_EDIT(), [path]);
  return (
    <Box direction='column' width={{min: '280px'}} pad={{horizontal: 'l', top: 'spacing20'}} background="module">
      {isLoading ? (
        <ShimmerBox height="40px" />
      ) : (
        <Text size="2xl" color="textTitle" weight={700}>
          {name}
      
        </Text>
      )}
      
      <StyledButton margin={{bottom: 'xxs'}}onClick={handleClick('basic_properties')}>
        <StyledText weight={400}>
          Basic Properties
        </StyledText>
      </StyledButton>
      {groups.map((option) => (
        <StyledButton margin={{bottom: 'xxs'}} key={option.id} onClick={handleClick(option.id as string)}>
          <StyledText weight={400}>
            {option.name}
          </StyledText>
        </StyledButton>
      ))}
      {isRoleEditPage && <StyledButton margin={{bottom: 'xxs'}}onClick={handleClick('activity_log')}>
        <StyledText weight={400}>
          Activity Log
        </StyledText>
      </StyledButton>}
      
      <StyledButton margin={{bottom: 'xxs'}}onClick={handleClick('final_setup')}>
        <StyledText weight={400}>
          Final Setup
        </StyledText>
      </StyledButton>
    </Box>
  );
};

export default RoleSetupSidebar;